import { config, gameState } from '@js/state';

export default class EndScene extends Phaser.Scene {
  constructor() {
    super({
      key: 'EndScene',
    });
  }

  preload() {
    this.load.image('gameOver', 'assets/EndScreenAssets/Game Over.png');

    this.load.image('correctIcon', 'assets/EndScreenAssets/correctIcon.png');

    this.load.image('incorrectIcon', 'assets/EndScreenAssets/incorrectIcon.png');

    this.load.image('retryButton', 'assets/EndScreenAssets/Retry Button.png');

    this.load.image('hintIcon', 'assets/EndScreenAssets/hintIcon.png');

    this.load.image('nextButton', 'assets/EndScreenAssets/Button CTA.png');

    this.load.image('endScreenOverlay', 'assets/EndScreenAssets/end screen.png');

    this.load.image('okayButton', 'assets/EndScreenAssets/okaybutton.png');

    this.load.image('rewardEarned', 'assets/EndScreenAssets/Rewards earned!.png');

    this.load.image('rewardName', 'assets/EndScreenAssets/Compass.png');

    this.load.image('retryHover', 'assets/EndScreenAssets/RetryHover.png');

    this.load.image('okayHover', 'assets/EndScreenAssets/okayHover.png');

    this.load.image('okayDisabled', 'assets/EndScreenAssets/okayDisabled.png');

    this.load.image('nextHover', 'assets/EndScreenAssets/next hover.png');

    this.load.image('youWon', 'assets/EndScreenAssets/You Won.png');
  }

  create() {
    this.cameras.main.fadeIn(1000, 255, 255, 255);

    this.endOverlay = this.add.sprite(
      config.width / 2,
      config.height / 2,
      'endScreenOverlay',
    );
    this.spotlight = this.add.sprite(config.width / 2, config.height / 2, 'spotlight');
    this.anims.create({
      key: 'spotlightOpen',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 0,
        end: 188,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.anims.create({
      key: 'spotlightClose',
      frames: this.anims.generateFrameNames('spotlight', {
        start: 189,
        end: 214,
        zeroPad: 0,
        prefix: 'spotlight0',
        suffix: '.png',
      }),
      frameRate: 20,
      repeat: 0,
    });

    this.endConfetti = this.add.sprite(
      config.width / 2,
      config.height / 2,
      'endConfetti',
    );
    this.anims.create({
      key: 'endConfetti',
      frames: this.anims.generateFrameNames('endConfetti', {
        start: 0,
        end: 120,
        zeroPad: 0,
        prefix: 'seq_0_',
        suffix: '.png',
      }),
      frameRate: 40,
      repeat: 0,
    });

    this.time.delayedCall(
      2000,
      function () {
        this.spotlight.play('spotlightOpen');
      },
      [],
      this,
    );

    this.gameOver = this.add
      .sprite(config.width / 2, config.height / 2, 'youWon')
      .setAlpha(0);
    this.tweens.add({
      targets: this.gameOver,
      ease: 'Expo.easeInOut',
      duration: 1000,
      delay: 300,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.gameOver],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2,
        getEnd: () => config.height / 2 - 50,
      },
      yoyo: false,
      loop: 0,
    });

    this.nextButton = this.add
      .sprite(config.width / 2, 740, 'nextButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.iconDisplay = this.add
      .sprite(config.width / 2 - 80, config.height / 2 + 100, 'correctIcon')
      .setAlpha(0);

    if (gameState.gameWin == false) {
      this.nextButton.setTexture('retryButton');
      this.gameOver.setTexture('gameOver');
      this.iconDisplay.setTexture('incorrectIcon');
      this.retryText = this.add
        .text(
          config.width / 2 - 140,
          config.height / 2 + 200,
          `Solve atleast 6 problems correctly \n to clear the game`,
          {
            fontFamily: 'font1',
            fontSize: '18px',
            fill: '#ffffff',
          },
        )
        .setAlign('center')
        .setAlpha(0);
      this.tweens.add({
        targets: [this.retryText],
        ease: 'Linear',
        duration: 300,
        delay: 3000,
        alpha: {
          getStart: () => 0,
          getEnd: () => 1,
        },
        y: {
          getStart: () => config.height / 2 + 200,
          getEnd: () => config.height / 2 + 150,
        },
        yoyo: false,
        loop: 0,
      });
    } else {
      this.endConfetti.play('endConfetti');
    }

    this.finalScore = this.add
      .text(
        config.width / 2 - 140,
        config.height / 2 + 140,
        `${gameState.score + 1}/${gameState.attempted + 1} Problems`,
        {
          fontFamily: 'font1',
          fontSize: '18px',
          fill: '#ffffff',
        },
      )
      .setAlpha(0);

    this.hintsUsed = this.add
      .text(
        config.width / 2 + 30,
        config.height / 2 + 140,
        `${gameState.hints} Hints Used`,
        {
          fontFamily: 'font1',
          fontSize: '18px',
          fill: '#ffffff',
        },
      )
      .setAlpha(0);

    this.hintDisplay = this.add
      .sprite(config.width / 2 + 80, config.height / 2 + 100, 'hintIcon')
      .setAlpha(0)
      .setScale(1);

    this.tweens.add({
      targets: [this.iconDisplay, this.hintDisplay],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      y: {
        getStart: () => config.height / 2 + 100,
        getEnd: () => config.height / 2 + 50,
      },
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.finalScore, this.hintsUsed],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => config.height / 2 + 140,
        getEnd: () => config.height / 2 + 100,
      },
      yoyo: false,
      loop: 0,
    });

    this.tweens.add({
      targets: [this.nextButton],
      ease: 'Linear',
      duration: 300,
      delay: 3000,
      alpha: {
        getStart: () => 0,
        getEnd: () => 1,
      },
      y: {
        getStart: () => 740,
        getEnd: () => 650,
      },
      yoyo: false,
      loop: 0,
    });

    this.reward = this.add
      .sprite(config.width / 2, config.height / 2, 'rewardAnim')
      .setScale(0.45);

    this.anims.create({
      key: 'rewardShow',
      frames: this.anims.generateFrameNames('rewardAnim', {
        start: 0,
        end: 74,
        zeroPad: 0,
        prefix: 'compass',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: 0,
    });
    this.anims.create({
      key: 'rewardLoop',
      frames: this.anims.generateFrameNames('rewardAnim', {
        start: 75,
        end: 155,
        zeroPad: 0,
        prefix: 'compass',
        suffix: '.png',
      }),
      frameRate: 30,
      repeat: -1,
    });

    this.okButton = this.add
      .sprite(config.width / 2, 740, 'okayButton')
      .setAlpha(0)
      .setInteractive({ cursor: 'pointer' });

    this.nextButton.on(
      'pointerover',
      pointer => {
        if (gameState.gameWin == false) {
          this.nextButton.setTexture('retryHover');
        } else {
          this.nextButton.setTexture('nextHover');
        }
      },
      this,
    );

    this.nextButton.on(
      'pointerout',
      pointer => {
        if (gameState.gameWin == false) {
          this.nextButton.setTexture('retryButton');
        } else {
          this.nextButton.setTexture('nextButton');
        }
      },
      this,
    );

    this.nextButton.on('pointerup', pointer => {
      if (gameState.gameWin == false) {
        gameState.attempted = 0;
        gameState.score = 0;
        gameState.hints = 0;
        gameState.gameWin = false;

        this.cameras.main.fadeOut(500, 255, 255, 255);

        this.cameras.main.once(
          'camerafadeoutcomplete',
          function (camera) {
            this.scene.stop('EndScene');
            this.scene.start('TutorialScene');
          },
          this,
        );
      } else {
        this.tweens.add({
          targets: [
            this.gameOver,
            this.iconDisplay,
            this.hintDisplay,
            this.finalScore,
            this.hintsUsed,
            this.nextButton,
          ],
          alpha: 0,
          duration: 300,
        });

        //this.spotlight.play("spotlightClose");

        this.time.delayedCall(
          1000,
          () => {
            this.reward.play('rewardShow');
            this.tweens.add({
              targets: this.okButton,
              ease: 'Linear',
              duration: 300,
              delay: 3000,
              alpha: 1,
              y: 650,
            });

            this.add.sprite(581, 126, 'rewardEarned').setOrigin(0);
            this.add.sprite(578, 580, 'rewardName').setOrigin(0);
          },
          this,
        );

        // this.spotlight.on(
        //   Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + "spotlightClose",
        //   () => {
        //     this.spotlight.play("spotlightOpen");
        //   },
        //   this
        // );

        this.reward.on(
          Phaser.Animations.Events.ANIMATION_COMPLETE_KEY + 'rewardShow',
          () => {
            this.reward.play('rewardLoop');
          },
          this,
        );
      }
    });

    this.okButton.on(
      'pointerover',
      () => {
        this.okButton.setTexture('okayHover');
      },
      this,
    );

    this.okButton.on(
      'pointerout',
      () => {
        this.okButton.setTexture('okayButton');
      },
      this,
    );

    this.okButton.on(
      'pointerup',
      () => {
        this.okButton.setTexture('okayDisabled');
        this.okButton.removeInteractive();
      },
      this,
    );
  }

  update() {}
}
